import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/auth";

const SESSION_TIMEOUT = 30 * 60 * 1000;
// const SESSION_TIMEOUT = 1 * 1000;

export default function useSessionTimeout() {
  const dispatch = useDispatch();

  useEffect(() => {
    const updateActivity = () => {
      sessionStorage.setItem("lastActivity", Date.now().toString());
    };

    const checkTimeout = () => {
      const lastActivity = parseInt(sessionStorage.getItem("lastActivity"), 10);
      if (!isNaN(lastActivity)) {
        const currentTime = Date.now();
        if (currentTime - lastActivity > SESSION_TIMEOUT) {
          sessionStorage.clear();
          dispatch(logout());
          window.location.href = "/login"; // Redirect to login page
        }
      }
    };

    // Set initial activity timestamp
    updateActivity();

    // Events that update activity
    const events = ["mousemove", "keydown", "click"];
    events.forEach((event) => window.addEventListener(event, updateActivity));

    const interval = setInterval(checkTimeout, 60000); // check every 1 minute

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, updateActivity)
      );
      clearInterval(interval);
    };
  }, []);
}
